const LOW_HP_THRESHOLD = 4;

export type DamageOverlay = {
  triggerFlash: () => void;
  updateVignette: (hp: number) => void;
  dispose: () => void;
};

export function createDamageOverlay(): DamageOverlay {
  const flashEl = document.createElement("div");
  flashEl.id = "damage-overlay";
  flashEl.style.cssText = `
    position: fixed;
    inset: 0;
    background: rgba(220, 0, 0, 0.35);
    pointer-events: none;
    z-index: 15;
    opacity: 0;
    transition: opacity 0.5s ease-out;
  `;

  const vignetteEl = document.createElement("div");
  vignetteEl.id = "danger-vignette";
  vignetteEl.style.cssText = `
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 14;
    box-shadow: inset 0 0 80px rgba(255, 0, 0, 0);
    transition: box-shadow 0.4s ease;
  `;

  document.body.appendChild(vignetteEl);
  document.body.appendChild(flashEl);

  let flashTimer: ReturnType<typeof setTimeout> | null = null;

  function triggerFlash() {
    if (flashTimer !== null) {
      clearTimeout(flashTimer);
      flashTimer = null;
    }

    // Snap to visible, then schedule fade
    flashEl.style.transition = "none";
    flashEl.style.opacity = "1";

    // Force reflow so the snap takes effect before we set the transition
    void flashEl.offsetHeight;

    flashEl.style.transition = "opacity 0.3s ease-out";
    flashEl.style.opacity = "0";

    flashTimer = setTimeout(() => {
      flashTimer = null;
    }, 500);
  }

  function updateVignette(hp: number) {
    if (hp <= LOW_HP_THRESHOLD) {
      vignetteEl.style.boxShadow = "inset 0 0 80px rgba(255, 0, 0, 0.3)";
    } else {
      vignetteEl.style.boxShadow = "inset 0 0 80px rgba(255, 0, 0, 0)";
    }
  }

  function dispose() {
    if (flashTimer !== null) clearTimeout(flashTimer);
    flashEl.remove();
    vignetteEl.remove();
  }

  return { triggerFlash, updateVignette, dispose };
}
